import { render } from "./SectionDetailView.vue?vue&type=template&id=2f0e7287"
import script from "./SectionDetailView.vue?vue&type=script&lang=js"
export * from "./SectionDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__